import React, { VFC } from 'react';
import { SEO } from 'src/components';

const Component: VFC = () => (
  <>
    <SEO noIndex />
    <div>さいとまっぷ</div>
  </>
);

export default Component;
